var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6865 10.5572C13.097 11.7517 12.299 12.9426 11.4815 14.0113C10.6665 15.0766 9.84873 15.9989 9.23364 16.6555C9.15191 16.7428 9.07387 16.8252 9 16.9026C8.92613 16.8252 8.84809 16.7428 8.76636 16.6555C8.15127 15.9989 7.33352 15.0766 6.51853 14.0113C5.70098 12.9426 4.90303 11.7517 4.31351 10.5572C3.7179 9.35046 3.375 8.21965 3.375 7.25C3.375 4.1434 5.8934 1.625 9 1.625C12.1066 1.625 14.625 4.1434 14.625 7.25C14.625 8.21965 14.2821 9.35046 13.6865 10.5572ZM9 18.5C9 18.5 15.75 12.1029 15.75 7.25C15.75 3.52208 12.7279 0.5 9 0.5C5.27208 0.5 2.25 3.52208 2.25 7.25C2.25 12.1029 9 18.5 9 18.5Z",
    fill: "#16B054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.5C7.75736 9.5 6.75 8.49264 6.75 7.25C6.75 6.00736 7.75736 5 9 5C10.2426 5 11.25 6.00736 11.25 7.25C11.25 8.49264 10.2426 9.5 9 9.5ZM9 10.625C10.864 10.625 12.375 9.11396 12.375 7.25C12.375 5.38604 10.864 3.875 9 3.875C7.13604 3.875 5.625 5.38604 5.625 7.25C5.625 9.11396 7.13604 10.625 9 10.625Z",
    fill: "#16B054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.2e41ae607cc4fce261edcab993c28866.svg";
export { ForwardRef as ReactComponent };